/* ### UTILS ### */

const extractMediaInfo = (obj: any, target: any) => {
    let result = null
    let extract = null

    if (obj.file && obj.file[target]) {
        extract = obj.file[target]
    } else if (obj[target]) {
        extract = obj[target]
    }

    if (target === 'type') {
        if (extract && extract === 'image/jpeg') result = 'jpg'
        if (extract && extract === 'application/pdf') result = 'pdf'
        if (extract && extract === 'image/png') result = 'png'
    } else if (target === 'size') {
        result = extract || null
    }

    return result
}

/**
 * @async
 * @description format media to match DB media
 * @param {Object} media
 * @param {Object}
 */
export const formatMediaFromRaw = (media: any) => {
    if (media) {
        const formated = {
            id: media.id,
            url: media.url,
            name: media.name || media.file.name,
            source: 'library',
            quality: 'standard',
            date: new Date(),
            ext: media.ext ?? extractMediaInfo(media, 'type'),
            size: extractMediaInfo(media, 'size'),
            file: media,
            state: media.state || 'local',
        }

        return formated
    }
    return null
}

export const pictureExt = ['jpeg', 'jpg', 'png']
export const documentExt = ['pdf']
